import React from "react";

export type OnboardingStatus = "in_progress" | "completed" | "failed" | "check_error";

export type OnboardingStatusPerBusiness = Record<string, OnboardingStatus> | null;

export const onboardingStatusContext = React.createContext<OnboardingStatusPerBusiness>(null);

export function useOnboardingStatus() {
  return React.useContext(onboardingStatusContext);
}
